import mitt from 'mitt';

export const EVENT_NAME_CHANGE_STATE = 'EVENT_NAME_CHANGE_STATE';
export const EVENT_NAME_CHANGE_STATE_START = 'EVENT_NAME_CHANGE_STATE_START';
export const EVENT_NAME_CHANGE_STATE_FINISH = 'EVENT_NAME_CHANGE_STATE_FINISH';
export const EVENT_NAME_BACK_HOME = 'EVENT_NAME_BACK_HOME';
export const EVENT_NAME_ONLOAD = 'EVENT_NAME_ONLOAD';
export const EVENT_CLICK_TAG = 'EVENT_CLICK_TAG';
export const EVENT_ENTER_ANIM_FINISH = 'EVENT_ENTER_ANIM_FINISH';

type Events = {
  [EVENT_NAME_CHANGE_STATE]: number;
  [EVENT_NAME_CHANGE_STATE_START]: number;
  [EVENT_NAME_CHANGE_STATE_FINISH]: number;
  [EVENT_NAME_BACK_HOME]: void;
  [EVENT_NAME_ONLOAD]: void;
  [EVENT_CLICK_TAG]: number;
  [EVENT_ENTER_ANIM_FINISH]: void;
};

const emitter = mitt<Events>();
export default emitter;
